import { render } from "./CodeEditor.vue?vue&type=template&id=670e05ca&ts=true"
import script from "./CodeEditor.vue?vue&type=script&lang=ts"
export * from "./CodeEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__